import React from 'react';
// Components
import InterviewsTable from './InterviewsTable/InterviewsTable';

const Interviews: React.FC = () => {
  return <InterviewsTable />;
};

export default Interviews;
